module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am175-6b679a3b45f2c2bdbeec77845f3161e9.jpg";